import { call, put } from 'redux-saga/effects';
import { createCompany, acceptTerms } from '../../../services/companyService';
import { setMessage } from '../../../store/reducers/message';
import { setLoading } from '../../../store/reducers/loading';
import queryString from '../../../services/queryString';
import location from '../../../services/location';
import { parse } from '../../../services/queryString';
import { BS_UI } from '../../../constants/global';
import { getToken } from '../../../services/recaptcha';
interface IAction {
    type: string;
    form: any;
}

export const getDefaultPlan = (type: string) => {
    switch (type) {
        case 'reseller':
            return 'AGENT';
        case 'operator':
            return 'ACCELERATE';
        default:
            return 'ACCELERATE';
    }
};

export const getPlanName = (type: string) => {
    const params = parse(location.search);
    return params.plan !== undefined ? params.plan : getDefaultPlan(type);
};

export const getPartnerSource = () => {
    const params = parse(location.search);
    return params.partnerSource !== undefined ? { partnerSource: params.partnerSource } : {};
};

export const getIndestination = () => {
    const params = parse(location.search);
    return params.indestination ? { indestination: params.indestination } : {};
};

export const getUtmParams = () => {
    const params = parse(location.search);
    const utmParams: Record<string, string> = {};

    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    utmKeys.forEach(key => {
        if (params[key] !== undefined) {
            utmParams[key] = params[key];
        }
    });

    return utmParams;
};

export function* submitCreateCompanyForm(action: IAction) {
    try {
        const { form } = action;
        const planName = getPlanName(form.businessType);
        const partnerSource = getPartnerSource();
        const indestination = getIndestination();
        const utmParams = getUtmParams();
        yield put(setLoading(true));
        // const token: string = yield getToken();
        yield call(createCompany, {
            // token,
            planName,
            ...partnerSource,
            ...indestination,
            ...utmParams,
            ...form,
        });
        yield call(acceptTerms, {
            // token,
        });

        location.href = queryString.appendQueryString(BS_UI, {
            source: 'signup',
            // eslint-disable-next-line @typescript-eslint/camelcase
            refresh_session: 1,
        });
    } catch (error) {
        // @ts-ignore
        yield put(setMessage(error.message, true));
        yield put(setLoading(false));
    }
}

export default submitCreateCompanyForm;
